import React from 'react';
import { motion } from 'framer-motion';
import SectionWrapper from './ui/SectionWrapper';
import { WHY_FEATURES } from '../constants';

const USP = () => (
  <SectionWrapper id="why" eyebrow="The difference" title="Why creators and brands choose LoopAI.">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {WHY_FEATURES.map(({ title, desc, icon: Icon }, i) => (
        <motion.div
          key={title}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: i * 0.06 }}
          className="group flex gap-4 rounded-2xl border border-slate-200 bg-white p-6 hover:border-brand/40 hover:shadow-[0_16px_40px_-24px_rgba(124,58,237,0.55)] transition-[box-shadow,border-color] duration-300"
          data-testid={`why-card-${i}`}
        >
          <span className="w-12 h-12 shrink-0 rounded-xl bg-violet-50 text-brand flex items-center justify-center transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
            <Icon size={22} />
          </span>
          <div>
            <h3 className="font-display font-bold text-ink">{title}</h3>
            <p className="text-sm text-slate-500 mt-1 leading-relaxed">{desc}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </SectionWrapper>
);

export default USP;
